export const CLOAK_ADDRESS = 'secret132u3k3snt949r2kvetj6j2csjketjaz3lgrlez';
export const CLOAK_OPERATOR = 'secret1ynvs4hp6dne3392naxym0pcujzvuxc5g2q0jlj';
export const DEADDROP_ADDRESS = 'secret17sx7jrdwr2uy6n3uzk5tykdgydp73mwsfhpenw';